import { USER_CREATE, USERS_GET } from './actionTypes'

/**
 * Get request to API to get all users.
 * @param {Object} Action Object
 */
export const getUsers = () => ({
  meta: { url: '/api/v1/users' },
  type: USERS_GET,
})

export const userCreate = (email, firstName, lastName) => ({
  meta: { data: { email, firstName, lastName }, method: 'post', url: `/api/v1/users` },
  type: USER_CREATE,
})
